import { handleActions } from 'redux-actions';
import cloneDeep from 'lodash/cloneDeep';
import update from 'immutability-helper';
import moment from 'moment';
import _ from 'lodash';

import { formatDateAndTime } from '../../../../utils/time';

import {
  loading,
  createCondition,
  deleteCondition,
  fetchInteraction,
  updateListPredicates,
  fetchUsersInteraction,
  fetchListChannels,
  fetchListChannelEvents,
  fetchListQuestions,
  fetchInteractionData,
  fetchFilterInteractionStatistics,
  fetchFilterEventStatistics,
  fetchFilterData,
  fetchEventData,
  createReport,
  setShowAnonymousUsers,
} from './actions';

export const initialState = {
  loading: false,
  listConditions: [],
  listInteractions: [],
  listData: null,
  updateListPredicates: [],
  listChannels: [],
  listChannelEvents: [],
  listUsersWithData: [],
  listQuestions: [],
  listDataFilter: [],
  listOriginalListUsers: [],
  usersWeek: 0,
  interactionStatistics: null,
  eventStatistics: null,
  userListTags: {},
  userStatistics: null,
  csvData: [],
  fromDate: '',
  untilDate: '',
  showAnonymousUsers: true,
  tagCategories: [],
};

export const reducer = handleActions(
  {
    [loading]: {
      next: state =>
        update(state, {
          loading: { $set: true },
        }),
    },

    [setShowAnonymousUsers]: {
      next: (state, { payload }) => {
        if (
          payload !== undefined &&
          (Boolean(payload) === true || Boolean(payload) === false)
        ) {
          return update(state, {
            showAnonymousUsers: { $set: payload },
          });
        } else {
          return state;
        }
      },
    },

    [createReport]: {
      next: (state, { payload }) => {
        const csvData = [];

        const eventName = _.get(state, 'eventStatistics.eventTitle', '');
        const eventDate = _.get(state, 'eventStatistics.eventDate', '');
        const usersWithData = _.get(state, 'eventStatistics.usersWithData', 0);
        const usersRate = _.get(state, 'eventStatistics.usersRate', 0);
        const validInteractions = _.get(state, 'eventStatistics.validInteractions', 0);
        const interactions = _.get(state, 'eventStatistics.interactions', []);

        const eventDateFormated = formatDateAndTime(eventDate);
        const csvBlankLine = [];

        const csvHeader = [
          'EVENT NAME',
          eventName,
          '',
          '',
          '',
          '',
          'DATE',
          eventDateFormated,
        ];

        csvData.push(csvHeader);
        csvData.push(csvBlankLine);
        csvData.push(csvBlankLine);

        const csvInteractionHeader = [
          'INTERACTION NAME',
          'TYPE',
          'PUBLISHED AT',
          'RECEIVED / OPENED',
          'ENGAGEMENT',
        ];
        csvData.push(csvInteractionHeader);
        interactions.forEach(interacion => {
          const name = _.get(interacion, 'name', '');
          const type = _.get(interacion, 'type', '');
          const date = _.get(interacion, 'publishedAt', '');
          const dateFormated = formatDateAndTime(date);
          const msgReceived = _.get(interacion, 'msgReceived', '');
          const msgOpened = _.get(interacion, 'msgOpened', '');
          const msgRate = msgReceived + `/` + msgOpened;
          const msgEngagementFormated = _.get(interacion, 'engagement', 0) + `%`;
          csvData.push([name, type, dateFormated, msgRate, msgEngagementFormated]);
        });

        csvData.push(csvBlankLine);
        csvData.push(csvBlankLine);

        const csvUsersStatistics = [
          'USERS',
          usersWithData,
          '',
          'USERS RATE',
          usersRate + `%`,
          '',
          'USERS INTERACTIONS',
          validInteractions,
        ];

        csvData.push(csvUsersStatistics);
        csvData.push(csvBlankLine);

        const csvUsersHeader = ['USER NAME', 'LANGUAGE'];
        csvData.push(csvUsersHeader);
        state.listUsersInteraction.forEach(user => {
          const userName = _.get(user, 'name', 'Anonymous user');
          const userLanguage = _.get(user, 'language', '');
          csvData.push([userName, userLanguage]);
        });

        return update(state, {
          csvData: { $set: csvData },
        });
      },
    },

    [createCondition]: {
      next: (state, { payload }) => {
        const index = state.listConditions.map(el => el.field).indexOf('Question');

        if (payload) {
          if (index > 0) {
            return update(state, {
              listConditions: { [index]: { $set: payload } },
              fromDate: { $set: '' },
              untilDate: { $set: '' },
            });
          }
          return update(state, {
            listConditions: { $push: [payload] },
            fromDate: { $set: '' },
            untilDate: { $set: '' },
          });
        } else {
          return state;
        }
      },
      throw: state => {
        return update(state, {
          loading: { $set: false },
          listConditions: { $set: [] },
        });
      },
    },

    [deleteCondition]: {
      next: (state, { payload }) => {
        if (payload + 1 === state.listConditions.length) {
          return update(state, {
            listConditions: { $splice: [[payload, 1]] },
            listUsersInteraction: { $set: [] },
            listData: { $set: [] },
            usersWeek: { $set: 0 },
            eventStatistics: { $set: null },
            interactionStatistics: { $set: null },
            validInteractions: { $set: 0 },
            usersRate: { $set: 0 },
            usersWithData: { $set: 0 },
            csvData: { $set: [] },
            fromDate: { $set: '' },
            untilDate: { $set: '' },
          });
        } else {
          return state;
        }
      },
      throw: state => {
        return update(state, {
          loading: { $set: false },
          listConditions: { $set: [] },
        });
      },
    },

    [fetchEventData]: {
      next: (state, { payload }) => {
        if (payload) {
          const listData = payload.listData;
          const listUsersWithData = payload.listUsersWithData;

          return update(state, {
            listData: { $set: listData },
            listUsersWithData: { $set: listUsersWithData },
          });
        }
        return state;
      },
      throw: state => {
        return update(state, {
          listData: { $set: [] },
          listUsersWithData: { $set: [] },
        });
      },
    },

    [fetchInteractionData]: {
      next: (state, { payload }) => {
        if (payload) {
          const listData = payload.listData;
          const listUsersWithData = payload.listUsersWithData;

          return update(state, {
            listData: { $set: listData },
            listUsersWithData: { $set: listUsersWithData },
          });
        }
        return state;
      },
      throw: state => {
        return update(state, {
          listData: { $set: [] },
          listUsersWithData: { $set: [] },
        });
      },
    },

    [fetchFilterData]: {
      next: (state, { payload }) => {
        if (payload) {
          const listData = payload.listData;
          const listUsersWithData = payload.listUsersWithData;

          return update(state, {
            listData: { $set: listData },
            listUsersWithData: { $set: listUsersWithData },
          });
        }
        return state;
      },
      throw: state => {
        return update(state, {
          loading: { $set: false },
          listData: { $set: [] },
          listUsersWithData: { $set: [] },
        });
      },
    },

    [fetchFilterEventStatistics]: {
      next: (state, { payload }) => {
        if (payload) {
          const validInteractions = _.get(payload, 'validInteractions', 0);
          const usersRate = _.get(payload, 'usersRate', 0);
          const usersWithData = _.get(payload, 'usersWithData', 0);
          return update(state, {
            eventStatistics: { $set: payload },
            validInteractions: { $set: validInteractions },
            usersRate: { $set: usersRate },
            usersWithData: { $set: usersWithData },
          });
        }
        return state;
      },
      throw: state => {
        return update(state, {
          eventStatistics: { $set: null },
          validInteractions: { $set: 0 },
          usersRate: { $set: 0 },
          usersWithData: { $set: 0 },
        });
      },
    },

    [fetchFilterInteractionStatistics]: {
      next: (state, { payload }) => {
        if (payload) {
          const validInteractions = _.get(payload, 'validInteractions', 0);
          const usersRate = _.get(payload, 'usersRate', 0);
          const usersWithData = _.get(payload, 'usersWithData', 0);
          return update(state, {
            interactionStatistics: { $set: payload },
            validInteractions: { $set: validInteractions },
            usersRate: { $set: usersRate },
            usersWithData: { $set: usersWithData },
          });
        }
        return state;
      },
      throw: state => {
        return update(state, {
          interactionStatistics: { $set: null },
          validInteractions: { $set: 0 },
          usersRate: { $set: 0 },
          usersWithData: { $set: 0 },
        });
      },
    },

    [fetchInteraction]: {
      next: (state, { payload }) => {
        if (payload.docs && payload.docs.length >= 0) {
          return update(state, {
            listInteractions: { $set: payload.docs },
          });
        }
        return state;
      },
      throw: state => {
        return update(state, {
          loading: { $set: false },
          listInteractions: { $set: [] },
        });
      },
    },

    [fetchListQuestions]: {
      next: (state, { payload }) => {
        if (payload && payload.docs && payload.docs.length === 1) {
          const questions = payload.docs[0].params.questions;
          let listQuestions = [];
          questions.forEach((question, idx) => {
            const keyQuestion = question.key;
            const options = question.options;
            if (keyQuestion.startsWith('_q')) {
              const newQuestion = {
                name: question.title,
                value: idx,
                options: options,
              };
              listQuestions.push(newQuestion);
            }
          });
          return update(state, {
            listQuestions: { $set: listQuestions },
          });
        }
        return state;
      },
      throw: state => {
        return update(state, {
          loading: { $set: false },
          listQuestions: { $set: [] },
        });
      },
    },

    [fetchUsersInteraction]: {
      next: (state, { payload }) => {
        if (payload.docs && payload.docs.length >= 0) {
          const users = payload.docs;
          const start = moment().subtract(1, 'weeks');
          const end = moment();

          const usersWeek = users.filter(user => {
            const isBetween = moment(user.createdAt).isBetween(start, end);
            if (isBetween) {
              return user;
            }
            return null;
          });

          return update(state, {
            listUsersInteraction: { $set: users },
            usersWeek: { $set: usersWeek.length },
          });
        }
        return state;
      },
      throw: state => {
        return update(state, {
          loading: { $set: false },
          listUsersInteraction: { $set: [] },
          usersWeek: { $set: 0 },
        });
      },
    },

    [fetchListChannels]: {
      next: (state, { payload }) => {
        if (payload.docs && payload.docs.length >= 0) {
          payload.docs = payload.docs.map(channel => {
            return { _id: channel._id, name: channel.name };
          });
          return update(state, {
            listChannels: { $set: payload.docs },
          });
        }
        return state;
      },
      throw: state => {
        return update(state, {
          loading: { $set: false },
          listChannels: { $set: [] },
        });
      },
    },

    [fetchListChannelEvents]: {
      next: (state, { payload }) => {
        const data = _.get(payload, 'docs', null);
        if (data && data.length >= 0) {
          return update(state, {
            listChannelEvents: { $set: data },
          });
        }
        return state;
      },
      throw: state => {
        return update(state, {
          loading: { $set: false },
          listChannelEvents: { $set: [] },
        });
      },
    },

    [updateListPredicates]: {
      next: (state, { payload }) => {
        if (payload && payload.length >= 0) {
          return update(state, {
            listPredicates: { $set: payload },
          });
        }
        return state;
      },
      throw: state => {
        return update(state, {
          loading: { $set: false },
          listPredicates: { $set: [] },
        });
      },
    },
  },
  cloneDeep(initialState)
);

export default reducer;
